module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('i', {
    staticClass: "icon icon-class"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6eed899d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/no-data.vue
// module id = 863
// module chunks = 34